const POINTS_PER_LEVEL = 1000;

export const MAX_EGG_LEVEL = 5;

export type EggData = {
  level: number;
  progress: number;
  currentPoints: number;
};

export const getLevelAndProgress = (points: number): EggData => {
  const level = Math.floor(points / POINTS_PER_LEVEL) + 1;

  return {
    level,
    progress: (points / POINTS_PER_LEVEL) % 1,
    currentPoints: level === MAX_EGG_LEVEL ? 0 : points - POINTS_PER_LEVEL * (level - 1),
  };
};

// It's technically possible for an egg to be past the max level, though not allowed by the backend
export const isEggMaxLevel = (points: number) => getLevelAndProgress(points).level >= MAX_EGG_LEVEL;
